import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'
import Login from '@/components/Login'
import Model from '@/components/Model'
import MainUndefined from '@/components/MainUndefined'
import SIdentify from '@/components/Identify'
import Privacy from '@/components/Privacy'
import MainFile from '@/components/MainFile'
import uploader from 'vue-simple-uploader'
import Vuex from 'vuex'
import md5 from 'js-md5'
import PrivacyApp from '../components/PrivacyApp.vue'
Vue.use(uploader)
Vue.component('s-identify', SIdentify)
Vue.use(Router)
Vue.use(Vuex)
Vue.prototype.$md5 = md5
Vue.prototype.bus = new Vue()
const store = new Vuex.Store({
  state: {
    // 存储token
    token: localStorage.getItem('token') ? localStorage.getItem('token') : ''
  },
  mutations: {
    // 修改token，并将token 存入localStorage中
    changeLogin (state, user) {
      state.token = user.token
      localStorage.setItem('token', user.token)
    }
  }
})
const router = new Router({
  base: 'hyAppView',
  mode: 'history',
  routes: [
    {
      path: '/main',
      name: 'main',
      component: Main
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/model',
      name: 'model',
      component: Model
    },
    {
      path: '/undefined',
      name: 'undefined',
      component: MainUndefined
    },
    {
      path: '/Privacy',
      name: 'Privacy',
      component: Privacy
    },
    {
      path: '/PrivacyApp',
      name: 'PrivacyApp',
      component: PrivacyApp
    },
    {
      path: '/file',
      name: 'file',
      component: MainFile
    }
  ],
  store
})
// 路由守卫
router.beforeEach((to, from, next) => {
  if (to.path === '/' || to.path === '/model' || to.path === '/login' || to.path === '/Privacy' || to.path === '/PrivacyApp') {
    next()
  } else {
    // 获取当前用户的令牌
    let token = localStorage.getItem('token')
    if (token === null || token === '') {
      next('/login')
    } else {
      next()
    }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js